import ListBrands from "../../../../components/@products/brands/ListBrands";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BrandPage() {

    return (
        <ListBrands 
            routeType={routeTypes.admin}
        />
    )
}       